module.exports = __webpack_public_path__ + "img/旅游活动-4@2x.e86fd6f6.png";